// dot-prop-immutable
import dotProp from 'dot-prop-immutable';

// client-shared
import { array } from '@goldblack/client-utils';

class MyTransience {
    init(value, setTransientState, resetTransientState) {
        this.value = value;
        this.setTransientState = setTransientState;
        this.resetTransientState = resetTransientState;
    }

    // path 위치의 값을 기본값으로 되돌리거나, path 없으면 전체 상태 리셋.
    resetState(path) {
        if (typeof path === 'string') {
            this.setTransientState((prevState) => {
                let defaultValue = dotProp.get(getTransientDefault(), path);
                return dotProp.set(prevState, path, defaultValue);
            });
        } else {
            this.resetTransientState();
        }
    }

    // path 위치에 값을 설정. path에 객체를 넘기면 여러 경로를 한 번에 갱신.
    setState(path, object) {
        if (typeof path === 'string') {
            this.setTransientState((prevState) => {
                return dotProp.set(prevState, path, object);
            });
        } else {
            this.setTransientState((prevState) => {
                for (let key of Object.keys(path)) {
                    prevState = dotProp.set(prevState, key, path[key]);
                }
                return prevState;
            });
        }
    }

    // path 위치의 현재 값을 읽음. path 없으면 전체 상태 반환.
    getValue(path) {
        if (typeof path === 'string') {
            return dotProp.get(this.value, path);
        } else {
            return this.value;
        }
    }

    // path가 가리키는 배열 끝에 arr을 이어붙임.
    concatState(path, arr) {
        this.setTransientState((prevState) => {
            let prevValue = dotProp.get(prevState, path);
            let newValue = array.concatArray(prevValue, arr);
            return dotProp.set(prevState, path, newValue);
        });
    }

    // path 배열에서 callback으로 찾은 첫 요소를 제거.
    removeState(path, callback) {
        this.setTransientState((prevState) => {
            let prevValue = dotProp.get(prevState, path);
            let newValue = array.removeInArray(prevValue, callback);
            return dotProp.set(prevState, path, newValue);
        });
    }

    // path 배열에서 callback으로 찾은 요소를 object로 교체.
    updateState(path, callback, object) {
        this.setTransientState((prevState) => {
            let prevValue = dotProp.get(prevState, path);
            let newValue = array.updateInArray(prevValue, callback, object);
            return dotProp.set(prevState, path, newValue);
        });
    }

    // path가 가리키는 배열 끝에 요소 하나 추가.
    addState(path, obj) {
        this.setTransientState((prevState) => {
            let prevValue = dotProp.get(prevState, path);
            let newValue = array.addInArray(prevValue, obj);
            return dotProp.set(prevState, path, newValue);
        });
    }

    // path가 가리키는 배열에서 마지막 요소 제거 (스택 pop).
    popState(path) {
        this.setTransientState((prevState) => {
            let prevValue = dotProp.get(prevState, path);
            let newValue = array.popInArray(prevValue);
            return dotProp.set(prevState, path, newValue);
        });
    }

    // path가 가리키는 배열에서 첫 요소 제거 (큐 shift).
    shiftState(path) {
        this.setTransientState((prevState) => {
            let prevValue = dotProp.get(prevState, path);
            let newValue = array.shiftInArray(prevValue);
            return dotProp.set(prevState, path, newValue);
        });
    }
}

var transience = new MyTransience();

export { transience };
